import { useProduct } from "src/context/ProductProvider";
import WeightLossDisplay from "./components/WeightLossDisplay";
import OndansetronDisplay from "./components/OndansetronDisplay";
import EmergencyContraceptionDisplay from "./components/EmergencyContraceptionDisplay";

const Display = () => {
  const category = useProduct((p) => p.category.name);

  if (category === "Nausea") {
    return <OndansetronDisplay />;
  }

  if (category === "Emergency Contraception") {
    return <EmergencyContraceptionDisplay />;
  }

  return <WeightLossDisplay />;
};

export default Display;
